import { Controller, useFieldArray, useWatch } from "react-hook-form";
import { Row, Col, Form } from "react-bootstrap";
import Select from "react-select";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { getData } from "../../../utils/api";
import { Select2Data } from "../../../utils/common";

const ProductSection = ({
  singleIndex,
  deliveryIndex,
  control,
  register,
  getValues,
  errors,
  setValue,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: `variants.${singleIndex}.double_variants.${deliveryIndex}.triple_variants`,
  });

  const tripleVariants =
    useWatch({
      control,
      name: `variants.${singleIndex}.double_variants.${deliveryIndex}.triple_variants`,
    }) || [];

  const [Diamonds, setDiamond] = useState([]);
  const getAllDiamond = async () => {
    const response = await getData(`/common/masters/all-diamond`);
    if (response?.success) {
      setDiamond(await Select2Data(response?.data, "diamond_id"));
    }
  };

  useEffect(() => {
    getAllDiamond();
  }, []);

  const [variantsError, setVariantsError] = useState("");

  useEffect(() => {
    register(
      `variants.${singleIndex}.double_variants.${deliveryIndex}.triple_variants`,
      {
        validate: (value) => {
          const isValid = value && value.length > 0;
          setVariantsError(
            isValid ? "" : "At least one third variant is required",
          );
          return isValid;
        },
      },
    );
  }, [register]);
  return (
    <>
      <div>
        {" "}
        {variantsError && <span className="text-danger">{variantsError}</span>}
      </div>

      {fields.map((product, productIndex) => (
        <Row key={product.id} className="mb-3 ">
          <Col md={3}>
            <Form.Group>
              <Form.Label>Third Variant</Form.Label>
              <Controller
                control={control}
                name={`variants.${singleIndex}.double_variants.${deliveryIndex}.triple_variants.${productIndex}.diamond_id`}
                rules={{
                  required: "Select Third Variant",
                }}
                render={({ field }) => (
                  // <Select
                  //   {...field}
                  //   options={Diamonds}
                  //   onChange={(selectedOption) => {
                  //     field.onChange(selectedOption.value);
                  //     setValue(
                  //       `variants.${singleIndex}.double_variants.${deliveryIndex}.triple_variants.${productIndex}.diamond_id`,
                  //       selectedOption,
                  //     );
                  //   }}
                  // />

                  <Select
                    {...field}
                    options={Diamonds.filter((diamond) => {
                      // Get all selected diamond ids except current row
                      const selectedIds = tripleVariants
                        .filter((_, idx) => idx !== productIndex)
                        .map((item) => item?.diamond_id?.value)
                        .filter(Boolean);

                      // Keep current selected value visible
                      return (
                        !selectedIds.includes(diamond.value) ||
                        diamond.value === field.value?.value
                      );
                    })}
                    value={field.value}
                    onChange={(selectedOption) => {
                      setValue(
                        `variants.${singleIndex}.double_variants.${deliveryIndex}.triple_variants.${productIndex}.diamond_id`,
                        selectedOption,
                        {
                          shouldDirty: true,
                          shouldValidate: true,
                        },
                      );
                    }}
                  />
                )}
              />

              {errors?.variants?.[singleIndex]?.double_variants?.[deliveryIndex]
                ?.triple_variants?.[productIndex]?.diamond_id && (
                <span className="text-danger">
                  {
                    errors?.variants?.[singleIndex]?.double_variants?.[
                      deliveryIndex
                    ]?.triple_variants?.[productIndex]?.diamond_id.message
                  }
                </span>
              )}
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label>Third Variant MRP</Form.Label>
              <Form.Control
                type="text"
                {...register(
                  `variants.${singleIndex}.double_variants.${deliveryIndex}.triple_variants.${productIndex}.mrp`,
                  {
                    required: "Third Variant MRP is required",
                    validate: (value) =>
                      value.length <= 200 ||
                      "Data must be 200 characters or less",
                  },
                )}
                onKeyDown={(e) => {
                  // Allow numbers, backspace, left arrow, right arrow, and a decimal point
                  if (
                    !/[0-9]/.test(e.key) && // Disallow any non-numeric key
                    e.key !== "Backspace" &&
                    e.key !== "ArrowLeft" &&
                    e.key !== "ArrowRight" &&
                    e.key !== "."
                  ) {
                    e.preventDefault(); // Prevent the event if it's not allowed
                  }

                  // Prevent entering more than one decimal point
                  if (e.key === "." && e.target.value.includes(".")) {
                    e.preventDefault();
                  }
                }}
              />

              {errors?.variants?.[singleIndex]?.double_variants?.[deliveryIndex]
                ?.triple_variants?.[productIndex]?.mrp && (
                <span className="text-danger">
                  {
                    errors?.variants?.[singleIndex]?.double_variants?.[
                      deliveryIndex
                    ]?.triple_variants?.[productIndex]?.mrp.message
                  }
                </span>
              )}
            </Form.Group>
          </Col>

          <Col md={2}>
            <Form.Group>
              <Form.Label>Third Variant Price</Form.Label>
              <Form.Control
                type="text"
                {...register(
                  `variants.${singleIndex}.double_variants.${deliveryIndex}.triple_variants.${productIndex}.price`,
                  {
                    required: "Third Variant Price is required",
                    validate: (value) => {
                      const mrp = getValues(
                        `variants.${singleIndex}.double_variants.${deliveryIndex}.triple_variants.${productIndex}.mrp`,
                      );

                      if (mrp && Number(value) > Number(mrp)) {
                        return "Third Variant Price cannot be greater than Third Variant MRP";
                      }
                      return true;
                    },
                  },
                )}
                onKeyDown={(e) => {
                  // Allow numbers, backspace, left arrow, right arrow, and a decimal point
                  if (
                    !/[0-9]/.test(e.key) && // Disallow any non-numeric key
                    e.key !== "Backspace" &&
                    e.key !== "ArrowLeft" &&
                    e.key !== "ArrowRight" &&
                    e.key !== "."
                  ) {
                    e.preventDefault(); // Prevent the event if it's not allowed
                  }

                  // Prevent entering more than one decimal point
                  if (e.key === "." && e.target.value.includes(".")) {
                    e.preventDefault();
                  }
                }}
              />

              {errors?.variants?.[singleIndex]?.double_variants?.[deliveryIndex]
                ?.triple_variants?.[productIndex]?.price && (
                <span className="text-danger">
                  {
                    errors?.variants?.[singleIndex]?.double_variants?.[
                      deliveryIndex
                    ]?.triple_variants?.[productIndex]?.price.message
                  }
                </span>
              )}
            </Form.Group>
          </Col>

          <Col md={12}>
            <button
              type="button"
              className="btn btn-danger mt-2"
              onClick={() => remove(productIndex)}
            >
              Remove Third Variant
            </button>
          </Col>
        </Row>
      ))}

      <button
        type="button"
        className="btn btn-secondary me-2"
        onClick={() => append({})}
      >
        + Add Third Variant
      </button>
    </>
  );
};

export default ProductSection;
